// Permissions & History Development Plan (13.10.2026), Phase 5 — "My
// Account" language preference. Scope per the plan is explicit: "controls
// menu, Case Control, My Tasks, History and status labels" — not the whole
// app. Keys are the existing English copy already shown in those screens;
// t(key) below falls back to the key itself when no translation exists, so
// English behaviour is completely unchanged and this dictionary can grow
// incrementally without ever risking a blank label.
export const translations = {
  de: {
    // ── Sidebar navigation (Layout.js) ──────────────────────────────────
    // Kayd's 15.10.2026 follow-up: "Dashboard" consistently for the menu
    // item, page title and main heading -- in German too.
    Dashboard: 'Dashboard',
    Applications: 'Anträge',
    Verifications: 'Verifizierungen',
    Users: 'Nutzer',
    Vehicles: 'Fahrzeuge',
    'Fleet Approvals': 'Flottenfreigaben',
    Protocols: 'Protokolle',
    'Damage Cases': 'Schadensfälle',
    'All Damage Reports': 'Alle Schadensmeldungen',
    'Carshare Registrations': 'Carsharing-Registrierungen',
    'Safety Reports': 'Sicherheitsmeldungen',
    Accommodation: 'Unterkünfte',
    'My Tasks': 'Meine Aufgaben',
    'Task Inbox': 'Aufgaben-Posteingang',
    'Case Control': 'Fallsteuerung',
    'Case Management': 'Fallsteuerung',
    // Kayd's 14.10.2026 nav follow-up — German "History" stays "Historie"
    // consistently everywhere it appears (previously "Verlauf" in one
    // place), and the Case Control sub-pages get their own clear labels
    // instead of overloading "Case Control" as both the group and a page.
    'Case Overview': 'Fallübersicht',
    'My Current Cases': 'Meine aktuellen Fälle',
    'My History': 'Meine Historie',
    'History & Document Rights': 'Historie & Dokumentrechte',
    History: 'Historie',
    Settings: 'Einstellungen',
    'Activity Log': 'Aktivitätsprotokoll',
    'Staff / Team & Roles': 'Team & Rollen',
    'Team & Roles': 'Team & Rollen',
    'Countries & Settings': 'Länder & Einstellungen',
    'Data Quality': 'Datenqualität',
    System: 'System',

    // ── Global bar (GlobalBar.js) ────────────────────────────────────────
    'My account': 'Mein Konto',
    'Log out': 'Abmelden',
    'Read-only': 'Nur Lesen',

    // ── My Tasks (MyTasks.js) ─────────────────────────────────────────────
    'Cases assigned to you. New tasks need your acceptance or decline before you\'re the responsible handler.': 'Ihnen zugewiesene Fälle. Neue Aufgaben müssen angenommen oder abgelehnt werden, bevor Sie zuständig sind.',
    'Claim an open case': 'Offenen Fall übernehmen',
    'Awaiting your response': 'Wartet auf Ihre Antwort',
    'In progress': 'In Bearbeitung',
    'Submitted — awaiting decision': 'Eingereicht — Entscheidung ausstehend',
    'Return requested': 'Rückgabe angefordert',
    'Accept task': 'Aufgabe annehmen',
    'Decline task': 'Aufgabe ablehnen',
    'Submit completed work': 'Erledigte Arbeit einreichen',
    'Request more time': 'Mehr Zeit anfordern',
    Comments: 'Kommentare',
    'Request return': 'Rückgabe anfordern',
    Claim: 'Übernehmen',
    'Nothing awaiting your response.': 'Nichts wartet auf Ihre Antwort.',
    'No active tasks.': 'Keine aktiven Aufgaben.',

    // ── Case Control (My Current Cases / My History / Case Overview) ─────
    'Your own assigned cases.': 'Ihre eigenen zugewiesenen Fälle.',
    'No current assignments.': 'Keine aktuellen Zuweisungen.',
    'No completed assignments yet.': 'Noch keine abgeschlossenen Zuweisungen.',
    Country: 'Land',
    Case: 'Fall',
    Type: 'Typ',
    Status: 'Status',
    'Assigned to': 'Zugewiesen an',
    Actions: 'Aktionen',
    Decision: 'Entscheidung',
    Decided: 'Entschieden',
    Documents: 'Dokumente',
    You: 'Sie',
    Assigned: 'Zugewiesen',
    Open: 'Offen',
    Assign: 'Zuweisen',
    'Assign case': 'Fall zuweisen',
    'Order Document': 'Auftragsdokument',
    'Delivery Note': 'Lieferschein',
    'Document being generated': 'Dokument wird erstellt',

    // ── Status labels (shared across Case Control pages) ──────────────────
    'Awaiting acceptance': 'Annahme ausstehend',
    Accepted: 'Angenommen',
    Declined: 'Abgelehnt',
    'Submitted for acceptance': 'Zur Entscheidung eingereicht',
    'Submitted — decision needed': 'Eingereicht — Entscheidung nötig',
    Done: 'Erledigt',
  },
};

export function translate(language, key) {
  if (!key) return key;
  return (translations[language] && translations[language][key]) || key;
}
